export const AUTH_CONFIG = {
  domain: 'smartmobility.auth0.com',
  clientId: 'Gudv5FUCLRK061p0pTOlLL3laBiBqvEW',
  audience: "https://api.curacao311.com",
  // callbackUrl: 'http://localhost:3000/callback',
  container: 'auth0-login-container'
}